module.exports = __webpack_public_path__ + "img/bmcl_gallery3.4235892c.jpg";